const ScholarApplyIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
    <path
      opacity="0.4"
      d="M6 20C6 27.7312 12.2687 34 20 34C27.7312 34 34 27.7312 34 20C34 12.2687 27.7312 6 20 6C12.2687 6 6 12.2687 6 20ZM13.2937 21.2938C13.6813 20.9063 14.3188 20.9063 14.7063 21.2938L17.875 24.4625L25.1875 14.4125C25.5125 13.9688 26.1375 13.8688 26.5812 14.1938C27.025 14.5188 27.125 15.1437 26.8 15.5875L18.8 26.5875C18.625 26.825 18.3625 26.975 18.0688 26.9937C17.775 27.0125 17.4875 26.9125 17.2813 26.7063L13.2813 22.7062C12.8938 22.3188 12.8938 21.6813 13.2813 21.2938H13.2937Z"
      fill="#FDC8D3"
    />
    <path
      d="M20 36C11.1625 36 4 28.8375 4 20C4 11.1625 11.1625 4 20 4C28.8375 4 36 11.1625 36 20C36 28.8375 28.8375 36 20 36ZM20 6C12.2688 6 6 12.2688 6 20C6 27.7313 12.2688 34 20 34C27.7313 34 34 27.7313 34 20C34 12.2688 27.7313 6 20 6ZM25.1938 14.4125C25.5187 13.9688 26.1437 13.8688 26.5875 14.1938C27.0312 14.5188 27.1313 15.1437 26.8063 15.5875L18.8063 26.5875C18.6313 26.825 18.3688 26.975 18.075 26.9938C17.7813 27.0125 17.4938 26.9125 17.2875 26.7062L13.2875 22.7062C12.9 22.3187 12.9 21.6813 13.2875 21.2938C13.675 20.9063 14.3125 20.9063 14.7 21.2938L17.8688 24.4625L25.1812 14.4125H25.1938Z"
      fill="#374151"
    />
  </svg>
);

export default ScholarApplyIcon;
